<template>
  <div>
    <el-form label-position="top" @submit.native.prevent>
      <el-row :gutter="10" class="u-mt-10 u-mb-10">
        <el-col :xs="24" :sm="12" :md="12" v-if="usuarioSemInstituicaoVinculada">
          <el-form-item class="u-mt-10" label="Instituição" key="instituicao">
            <el-select v-model="instituicaoSelected" filterable placeholder="Selecione (use 0 para Todas)" clearable @change="loadDashboard">
              <el-option label="TODAS AS INSTITUIÇÕES" :value="0"></el-option>
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="6" :md="6">
          <el-form-item class="u-mt-10" label="Ano" key="ano">
            <el-select v-model="anoSelected" filterable @change="loadDashboard">
              <el-option v-for="y in anosDisponiveis" :key="y" :label="String(y)" :value="y"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="6" :md="6">
          <el-form-item class="u-mt-10" label="Mês (opcional)" key="mes">
            <el-select v-model="mesSelected" filterable clearable @change="loadDashboard">
              <el-option v-for="m in meses" :key="m.value" :label="m.label" :value="m.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="6" :md="6">
          <el-form-item class="u-mt-10" label="Modalidade (PNAE)" key="modalidade">
            <el-select v-model="modalidadeSelected" filterable clearable @change="loadDashboard">
              <el-option label="CRECHE" value="creche"></el-option>
              <el-option label="PRÉ-ESCOLA" value="pre"></el-option>
              <el-option label="FUNDAMENTAL" value="fundamental"></el-option>
              <el-option label="EJA" value="eja"></el-option>
              <el-option label="INTEGRAL" value="integral"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" class="u-text-right">
          <el-button type="info" plain icon="el-icon-refresh" @click="loadDashboard">ATUALIZAR</el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="u-mt-10">
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card kpi kpi--primary">
          <div class="kpi__label">Estoque total</div>
          <div class="kpi__value">{{ formatNumber(cards.estoque_total, 3) }}</div>
          <div class="kpi__hint">Saldo (entradas - saídas)</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card kpi">
          <div class="kpi__label">Próximos do vencimento</div>
          <div class="kpi__value">{{ cards.alimentos_proximos_vencimento }}</div>
          <div class="kpi__hint">Próximos 15 dias</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card kpi">
          <div class="kpi__label">Consumo mensal</div>
          <div class="kpi__value">{{ formatNumber(cards.consumo_mensal, 3) }}</div>
          <div class="kpi__hint">Somatório de saídas</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card kpi">
          <div class="kpi__label">Custo da merenda (ano)</div>
          <div class="kpi__value">{{ formatMoney(cards.custo_merenda_ano) }}</div>
          <div class="kpi__hint">Entradas no ano</div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="u-mt-10">
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card kpi" :class="corAdequacao">
          <div class="kpi__label">Adequação nutricional</div>
          <div class="kpi__value">{{ cards.adequacao_nutricional_pct === null ? '—' : formatNumber(cards.adequacao_nutricional_pct, 1) + '%' }}</div>
          <div class="kpi__hint">{{ modalidadeSelected ? rotuloModalidade(modalidadeSelected) + ' vs PNAE' : 'Selecione uma modalidade' }}</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card kpi" :class="corAf">
          <div class="kpi__label">Agricultura Familiar</div>
          <div class="kpi__value">{{ cards.agricultura_familiar_pct === null ? '—' : formatNumber(cards.agricultura_familiar_pct, 1) + '%' }}</div>
          <div class="kpi__hint">Meta PNAE: 30%</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card kpi">
          <div class="kpi__label">Alunos com restrição</div>
          <div class="kpi__value">{{ cards.alunos_com_restricao || 0 }}</div>
          <div class="kpi__hint">Alergia/restrição/diabetes</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card kpi kpi--clickable" :class="corAlertas" @click="irParaConformidade">
          <div class="kpi__label">Alertas conformidade hoje</div>
          <div class="kpi__value">{{ cards.alertas_conformidade_hoje || 0 }}</div>
          <div class="kpi__hint">{{ (cards.alertas_conformidade_hoje || 0) > 0 ? 'Clique para revisar' : 'Sem conflitos hoje' }}</div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="u-mt-15">
      <el-col :xs="24" :sm="24" :md="24">
        <c-panel title="Consumo por alimento (Top 15)" titleIcon="fas fa-chart-bar">
          <div class="chart-box chart-box--md">
            <bar-chart class="chart-canvas" :chart-data="chartConsumoAlimento"></bar-chart>
          </div>
        </c-panel>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="u-mt-10" v-if="chartConsumoEscola.labels && chartConsumoEscola.labels.length">
      <el-col :xs="24" :sm="24" :md="24">
        <c-panel title="Consumo por escola (Top 15)" titleIcon="fas fa-chart-bar">
          <div class="chart-box chart-box--md">
            <bar-chart class="chart-canvas" :chart-data="chartConsumoEscola"></bar-chart>
          </div>
        </c-panel>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue'),
    BarChart: () => import('@/chart/BarChart')
  },
  data: () => ({
    anoSelected: (new Date()).getFullYear(),
    mesSelected: '',
    instituicaoSelected: '',
    modalidadeSelected: 'fundamental',
    anosDisponiveis: [],
    meses: [
      { label: 'Janeiro', value: 1 },
      { label: 'Fevereiro', value: 2 },
      { label: 'Março', value: 3 },
      { label: 'Abril', value: 4 },
      { label: 'Maio', value: 5 },
      { label: 'Junho', value: 6 },
      { label: 'Julho', value: 7 },
      { label: 'Agosto', value: 8 },
      { label: 'Setembro', value: 9 },
      { label: 'Outubro', value: 10 },
      { label: 'Novembro', value: 11 },
      { label: 'Dezembro', value: 12 },
    ],
    cards: {
      estoque_total: 0,
      alimentos_proximos_vencimento: 0,
      consumo_mensal: 0,
      custo_merenda_ano: 0,
      adequacao_nutricional_pct: null,
      agricultura_familiar_pct: null,
      alunos_com_restricao: 0,
      alertas_conformidade_hoje: 0
    },
    chartConsumoAlimento: { labels: [], datasets: [{ label: 'Quantidade', data: [], backgroundColor: '#346daa' }] },
    chartConsumoEscola: { labels: [], datasets: [{ label: 'Quantidade', data: [], backgroundColor: '#50964d' }] }
  }),
  computed: {
    usuarioSemInstituicaoVinculada () {
      const t = Number(this.$store.state.user.tipo)
      return [4, 5, 6, 7, 8, 10].includes(t)
    },
    corAdequacao () {
      const v = this.cards.adequacao_nutricional_pct
      if (v === null || v === undefined) return ''
      if (v < 80) return 'kpi--warning'
      if (v > 120) return 'kpi--danger'
      return 'kpi--success'
    },
    corAf () {
      const v = this.cards.agricultura_familiar_pct
      if (v === null || v === undefined) return ''
      return v >= 30 ? 'kpi--success' : 'kpi--danger'
    },
    corAlertas () {
      const v = this.cards.alertas_conformidade_hoje || 0
      return v > 0 ? 'kpi--warning' : 'kpi--success'
    }
  },
  mounted () {
    this.initAnos()
    if (this.usuarioSemInstituicaoVinculada) {
      this.instituicaoSelected = 0
    } else {
      this.instituicaoSelected = this.$store.state.config.instituicao && this.$store.state.config.instituicao.id ? this.$store.state.config.instituicao.id : ''
    }
    this.loadDashboard()
  },
  methods: {
    initAnos () {
      const current = (new Date()).getFullYear()
      const anos = []
      for (let y = current; y >= current - 7; y--) anos.push(y)
      this.anosDisponiveis = anos
    },
    async loadDashboard () {
      const instituicaoId = this.instituicaoSelected !== '' && this.instituicaoSelected !== null
        ? this.instituicaoSelected
        : (this.$store.state.config.instituicao && this.$store.state.config.instituicao.id)
      if (instituicaoId === '' || instituicaoId === null || instituicaoId === undefined) {
        window.eventBus.$emit('alert', { msg: 'Selecione uma instituição para visualizar o dashboard da merenda.', type: 'warning' })
        return
      }
      const params = []
      if (this.anoSelected) params.push(`ano=${this.anoSelected}`)
      if (this.mesSelected) params.push(`mes=${this.mesSelected}`)
      if (this.modalidadeSelected) params.push(`modalidade=${this.modalidadeSelected}`)
      const qs = params.length ? ('?' + params.join('&')) : ''
      try {
        const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/dashboard/` + instituicaoId + qs, this.$store.getters.getHeaderAuth)
        const data = res.data || {}
        this.cards = Object.assign({}, this.cards, data.cards || {})

        const ca = (data.charts && data.charts.consumo_por_alimento) ? data.charts.consumo_por_alimento : []
        this.chartConsumoAlimento.labels = ca.map(x => x.nome)
        this.chartConsumoAlimento.datasets[0].data = ca.map(x => Number(x.total || 0))

        const ce = (data.charts && data.charts.consumo_por_escola) ? data.charts.consumo_por_escola : []
        this.chartConsumoEscola.labels = ce.map(x => x.nome)
        this.chartConsumoEscola.datasets[0].data = ce.map(x => Number(x.total || 0))
      } catch (e) {
        this.$store.commit('throwException', e)
      }
    },
    formatMoney (value) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatNumber (value, decimals = 2) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
    },
    rotuloModalidade (m) {
      const map = { creche: 'Creche', pre: 'Pré-escola', fundamental: 'Fundamental', eja: 'EJA', integral: 'Integral' }
      return map[m] || m
    },
    irParaConformidade () {
      const id = this.instituicaoSelected || (this.$store.state.config.instituicao && this.$store.state.config.instituicao.id)
      if (!id || id === 0) {
        window.eventBus.$emit('alert', { msg: 'Selecione uma instituição específica para ver os conflitos.', type: 'warning' })
        return
      }
      const hoje = new Date().toISOString().slice(0, 10)
      this.$router.push(`/admin/merenda/conformidade-dietetica/${id}/${hoje}`)
    }
  }
}
</script>

<style scoped>
.kpi--success { border-left: 4px solid #50964d; }
.kpi--warning { border-left: 4px solid #E6A23C; }
.kpi--danger { border-left: 4px solid #b22222; }
.kpi--clickable { cursor: pointer; transition: transform 0.15s ease; }
.kpi--clickable:hover { transform: translateY(-2px); box-shadow: 0 2px 8px rgba(0,0,0,0.08); }
</style>

